/**
 * Tickets section: ticket types list and add/edit form.
 * Content (list + form) is passed as children.
 */

import { type ReactNode } from "react";
import { SmartSection } from "../SmartSection.tsx";

export interface TicketsSectionProps {
  id: string;
  icon: ReactNode;
  summary: string;
  filledCount: number;
  totalCount: number;
  hint?: string;
  children: ReactNode;
}

export function TicketsSection({
  id,
  icon,
  summary,
  filledCount,
  totalCount,
  hint,
  children,
}: TicketsSectionProps) {
  return (
    <SmartSection
      id={id}
      title="Типы билетов"
      icon={icon}
      summary={summary}
      filledCount={filledCount}
      totalCount={totalCount}
      hint={hint}
      defaultOpen={false}
    >
      <div className="space-y-3">{children}</div>
    </SmartSection>
  );
}
